import { Platform } from 'core/common/entities';
import { Languages } from 'core/localization/entities';
import { getCurrentLanguage } from 'core/localization/utils/getCurrentLanguage';

export type SystemState = {
  isTestingEnv: boolean;
  language: Languages;
  isAppleMobile: boolean;
  isApplePaySupported: boolean;
  isMobileDevice: boolean;
  platform: Platform;
  project: string;
};

export const systemInitialState: SystemState = {
  isTestingEnv: false,
  language: getCurrentLanguage(),
  isApplePaySupported: false,
  isAppleMobile: false,
  isMobileDevice: false,
  platform: Platform.UNKNOWN,
  project: '',
};
